/**
 * @license
 * Copyright Moda Operandi. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/ModaOperandi/mo-tools-engine/blob/master/LICENSE
 */

import { ModuleWithProviders,
         NgModule,
         Optional,
         SkipSelf }                from '@angular/core';

export *                           from './index';

import { AppConfig }               from '../app-config';
import { AuthErrorStateService }   from './error-handlers/auth-error-state.service';
import { CsrfConfig }              from './tokens/csrf-config';
import { CsrfService }             from './tokens/csrf.service';
import { HttpErrorHandlerService } from './error-handlers/http-error-handler.service';
import { LoginComponent }          from './login-logout/login.component';
import { LogoutComponent }         from './login-logout/logout.component';
import { ResourceApiConfig }       from '@mo-tools-engine/common';
import { SessionService }          from './sessions/session.service';
import { SessionApiService }       from './sessions/session-api.service';
import { TokenService }            from './tokens/token.service';

@NgModule({
  exports: [ LoginComponent, LogoutComponent ],
  declarations: [ LoginComponent, LogoutComponent ]
})
export class AuthModule {

  // --- Module Constructor ---

  constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
    if(parentModule) {
      throw new Error('AuthModule is already loaded. Import it only once');
    }
  }

  // --- Public Methods ---

  public static forRoot(sessionApiServiceConfig: ResourceApiConfig,
                        csrfServiceConfig: CsrfConfig,
                        appConfig: AppConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [ CsrfService,
                   AuthErrorStateService,
                   HttpErrorHandlerService,
                   SessionApiService,
                   SessionService,
                   TokenService,
                   {provide: ResourceApiConfig, useValue: sessionApiServiceConfig},
                   {provide: CsrfConfig, useValue: csrfServiceConfig},
                   {provide: AppConfig, useValue: appConfig}
                 ]
    }
  }

}